<script setup lang="ts">
import { Planungsgeschaeft } from '@/models/Planungsgeschaeft';
import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { DocumentCollection, type Document } from '@/models/Document';
import type { KtgTableHeaderProps, KtgTableSortEntry } from '@kp/geofy-vuejs-lib/tg-system/components/KpTableTypes.js';
import { getI18n } from '@/helpers/i18n';
import { onMounted, ref, type Ref } from 'vue';
import KtgTable from '@kp/geofy-vuejs-lib/tg-system/components/KpTable.vue';
import { buildUrl } from '@/helpers/api.js';

const props = defineProps<{
    geschaeft: Planungsgeschaeft;
}>();
const docs = new DocumentCollection();

const tableHeaders = ref<KtgTableHeaderProps[]>([
    {
        title: getI18n().t('filename'),
        dataProperty: 'filename',
        sortable: true,
        sizing: 'min-content'
    },
    {
        title: getI18n().t('kategorie'),
        dataProperty: 'parent_context',
        sortable: true
    },
    {
        title: getI18n().t('created'),
        dataProperty: 'created',
        sortable: true
    },
    {
        title: '',
        dataProperty: 'download',
        sticky: true,
        sortable: false
    }
]);

const actPage: Ref<number> = ref(1);
const actPageSize: Ref<number> = ref(200);
const actTableSort: KtgTableSortEntry[] = [{ dataProperty: 'id', direction: 'ascending' } as KtgTableSortEntry];
const { models, tableSort, pageSize } = useCollection(docs, {
    autoload: false,
    page: actPage,
    pageSize: actPageSize,
    tableSort: actTableSort,
    collectionsFilter: [
        {
            property: 'parent_id',
            value: props.geschaeft.id
        },
        {
            property: 'parent_entity',
            value: 'planungsgeschaeft'
        }
    ]
} as UseCollectionOptions);

onMounted(async () => {
    await docs.query();
});

function getDocumentUrl(item: Document): string {
    return buildUrl('/Document/downloadDocument', {
        document_id: item.id
    });
}
</script>

<template>
    <KtgTable v-model:sort="tableSort" v-model:pageSize="pageSize" :headers="tableHeaders" :data="models"
        ><template #[`item.filename`]="{ item }">
            <div class="titleCol" :title="item.filename">{{ item.filename }}</div>
        </template>
        <template #[`item.parent_context`]="{ item }">
            {{ getI18n().t(item.parent_context || '') }}
        </template>
        <template #[`item.created`]="{ item }">
            {{ item.created?.formatIf('DD.MM.YYYY') }}
        </template>
        <template #[`item.download`]="{ item }">
            <ktg-table-button :href="getDocumentUrl(item)" icon="download">{{
                getI18n().t('download')
            }}</ktg-table-button>
        </template></KtgTable
    >
</template>

<style scoped lang="scss">
.titleCol {
    max-width: 400px;
    text-overflow: ellipsis;
    overflow: clip;
}
</style>
